// extracted by mini-css-extract-plugin
module.exports = {"main":"Companies_main__kDxSm","companies__list":"Companies_companies__list__KNkw5","companies__card":"Companies_companies__card__4PDD1"};